import React from "react";
import { IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonSkeletonText } from "@ionic/react";
import classNames from "classnames/bind";
import styles from "./OrderSummary.module.scss";
import { Product as TProduct } from "@core/types";
import { CartDataProductsItem } from "../../providers/cartDataStore";
import CartProductCard from "../../core/src/entities/Product/CartProductCard";
import { useConfig } from "../../providers/config";

interface IOrderSummaryProductsList {
  productsMap: Record<string, TProduct>;
  cartProducts: CartDataProductsItem[];
  title: string;
  loading: boolean;
}

const cx = classNames.bind(styles);

const OrderSummaryProductsList: React.FC<IOrderSummaryProductsList> = ({
  productsMap,
  cartProducts,
  title,
  loading,
}) => {
  const config = useConfig();

  return (
    <IonCard className={cx("orderSummary")}>
      <IonCardHeader className={cx("orderSummaryHeader")} color="primary">
        <IonCardTitle className={cx("orderSummaryTitle")}>{title}</IonCardTitle>
      </IonCardHeader>
      <IonCardContent className={cx("orderSummaryContent")}>
        {loading ? (
          <div className="flex flex-col gap-4 my-6 mx-4">
            <IonSkeletonText animated className="m-0 h-28" />
          </div>
        ) : (
          cartProducts?.map((cartItem) => {
            const product = productsMap[cartItem.id];
            return product ? (
              <CartProductCard
                showCounter={config?.showOrderPageProductCardCounter}
                cartItem={cartItem}
                product={product}
                key={cartItem.id}
              />
            ) : null;
          })
        )}
      </IonCardContent>
    </IonCard>
  );
};

export default OrderSummaryProductsList;
